import {FooterTabFragment} from "../../shared/FooterTabFragment";
import React from "react";
import {Box} from "@mui/material";
import {TabInfo, Tabs} from "../../shared/TabsContainer";
import {GAMES, GameTabType} from "../Games";
import {
  HeaderTabsContainer,
  HeaderTabsContainerProps,
  HeaderTabsContainerState
} from "../../shared/HeaderTabsContainer";
import {PathComponent, PathProps} from "../../index";
import {GameChartsFragment} from "./GameChartsFragment";
import {Game} from "../types";

function createTabInfo(game: Game): TabInfo<GameTabType> {
  return {
    type: game.id as GameTabType,
    path: game.id,
    text: game.name,
    render: (path: PathProps) => <GameChartsFragment gameId={game.id} path={path}/>,
  }
}

const TABS: Tabs<GameTabType> = {
  items: GAMES.map(game => createTabInfo(game)),
  containerId: "charts",
};

type ChartsTabsContainerProps = HeaderTabsContainerProps<GameTabType> & {}

type ChartsTabsContainerState = HeaderTabsContainerState<GameTabType> & {}

class ChartsTabsContainer extends HeaderTabsContainer<GameTabType, ChartsTabsContainerProps, ChartsTabsContainerState> {
}

export class ChartsFragment extends FooterTabFragment {

  static nestedPaths(): PathComponent[] {
    return ChartsTabsContainer.nestedPathsFromTabs(TABS);
  }

  getTitle(): string {
    return "Charts";
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", flexGrow: 1}}>
      <ChartsTabsContainer path={this.props.path} tabs={TABS}/>
    </Box>;
  }
}
